<template>
  <div>
    <van-address-list
      v-model="chosenAddressId"
      :list="list"
      :default-tag-text="$t('common.default')"
      :add-button-text="$t('address.add')"
      @add="onAdd"
      @edit="onEdit"
      @select="selectAddress"
    />
  </div>
</template>

<script>
import { getAllAddressDetail } from '@/api/address'

export default {
  data() {
    return {
      chosenAddressId: 0,
      list: [],
      chosenLogisticsCompanyId: this.$route.query.logisticsCompanyId,
    }
  },
  created() {
    this.fetchAddress()
  },
  methods: {
    fetchAddress() {
      getAllAddressDetail().then(rep => {
        rep.data.forEach(a => {
          this.list.push({
            id: a.id,
            name: a.contact + (a.contactIdNum ? '(' + a.contactIdNum + ')' : '' ),
            tel: a.contactNumber,
            address: (a.tag ? '[' + a.tag + '] ' :'') + a.address,
            isDefault: a.isDefault,
          })
          if (a.isDefault) {
            this.chosenAddressId = a.id
          }
        })
        if (this.$route.query.id) {
          this.chosenAddressId = parseInt(this.$route.query.id)
        }
      })
    },
    onAdd() {
      this.$router.push('/address/edit')
    },
    onEdit(item, index) {
      this.$router.push('/address/edit?id=' + item.id)
    },
    selectAddress(item, index) {
      this.$router.push('/shoppingcart?addressId=' + item.id + '&logisticsCompanyId=' + this.chosenLogisticsCompanyId)
    }
  }
}
</script>

<style>
.van-address-list__bottom {
  bottom: 4rem;
}
.van-address-item {
  border: 1px solid #EBEDF0;
}
</style>